import type { SVGProps } from "react";

export function IconBlueCoinDollar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <circle
        cx="24"
        cy="24"
        r="20"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M24 10L24 38M31.5 18C31.5 16.8133 31.0601 15.6533 30.236 14.6666C29.4119 13.6799 28.2406 12.9108 26.8701 12.4567C25.4997 12.0026 23.9917 11.8838 22.5368 12.1153C21.082 12.3468 19.7456 12.9182 18.6967 13.7574C17.6478 14.5965 16.9335 15.6656 16.6441 16.8295C16.3547 17.9933 16.5033 19.1997 17.0709 20.2961C17.6386 21.3925 18.5999 22.3295 19.8332 22.9888C21.0666 23.6481 22.5166 24 24 24C25.4834 24 26.9334 24.3519 28.1668 25.0112C29.4001 25.6705 30.3614 26.6075 30.9291 27.7039C31.4968 28.8003 31.6453 30.0067 31.3559 31.1705C31.0665 32.3344 30.3522 33.4035 29.3033 34.2426C28.2544 35.0818 26.918 35.6532 25.4632 35.8847C24.0083 36.1162 22.5003 35.9974 21.1299 35.5433C19.7594 35.0892 18.5881 34.3201 17.764 33.3334C16.9399 32.3467 16.5 31.1867 16.5 30"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
